import { CampaignDto } from '@shared/services/apiService/apiService';
import { CampaignFormAnalysisPlan, CreateCampaignFormValue } from '../model/type';

type CampaignAnalysisPlanSource =
  | CreateCampaignFormValue['analysisPlan']
  | CampaignDto['analysisPlan']
  | null
  | undefined;

export const normalizeCampaignAnalysisPlan = (
  analysisPlan?: CampaignAnalysisPlanSource,
): CampaignFormAnalysisPlan => ({
  analysisTemplate: analysisPlan?.analysisTemplate || '',
  summaryPrompt: analysisPlan?.summaryPrompt || '',
  triggerType: analysisPlan?.triggerType ?? 'call-end',
});
